import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import OpenInNewIcon from '@mui/icons-material/OpenInNewRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { authSelectors } from 'app-components/flux/auth';
import { getEnvironmentConfig } from 'app-components/utils/core';

import VerifyEmail from 'assets/illustrations/Mail-and-Check.png';

const VerifyEmailForIdentityVerification = (props) => {
  const { emailAddress } = props;

  const theme = useTheme();

  // const [emailSentAgain, setEmailSentAgain] = useState(false);

  const authSession = useSelector(authSelectors.getAuthSession);

  const openMyAccount = () => {
    window.open(`${getEnvironmentConfig().myaccount_url}?hide-nav&bearer=${authSession.accessToken}`);
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center' width='100%' sx={{ textAlign: 'center' }}>
      <Typography>One more thing - we need to verify your email address.</Typography>
      <Box display='flex' alignItems='center' mt={2} mb={2}>
        <img style={{ height: 180, width: 'auto' }} src={VerifyEmail} alt='email-check' />
        <Box textAlign='left' ml={1}>
          <Typography variant='paragraphRegular' color='textSecondary'>
            Email address
          </Typography>
          <Typography>{emailAddress}</Typography>
        </Box>
      </Box>
      <Box mt={5} px={4} width={650}>
        <Typography variant='paragraphRegular' color='textSecondary'>
          {'We’ll send you an email with a verification link. If you don’t see the email after it’s sent, ' +
            'please check your spam or junk mail folders. Edit your email in '}
          <Typography
            component='span'
            onClick={openMyAccount}
            sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
            variant='inherit'
          >
            My Account&nbsp;
            <OpenInNewIcon style={{ fontSize: 'inherit' }} />
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};
VerifyEmailForIdentityVerification.propTypes = {
  emailAddress: PropTypes.string,
};

export default VerifyEmailForIdentityVerification;
